import { AllTypes, Nodes, generateTestIdValue } from './generate-test-id-value';

type ReturnVal = {
  'data-testid': string;
};

type CustomOpt = {
  id: string;
};

export function generateTestId(customOpt: CustomOpt): ReturnVal;
export function generateTestId(type: AllTypes, nodes?: Nodes): ReturnVal;
export function generateTestId(
  typeOrCustomOpt: AllTypes | CustomOpt,
  nodes?: Nodes
) {
  return {
    'data-testid':
      typeof typeOrCustomOpt === 'string'
        ? generateTestIdValue(typeOrCustomOpt, nodes)
        : typeOrCustomOpt.id,
  };
}

export default generateTestId;
